module.exports = __webpack_public_path__ + "../resources/images/illustration_archive-ee13ba0859a0256cd6be16e8d5e3ee4d.svg";